document.addEventListener("variant:changed",function(event){window.Shoppad.apps.infiniteoptions.init()});
//# sourceMappingURL=/s/files/1/0409/4043/7668/t/28/assets/custom.js.map?v=1750270337
